import React from "react";
import classNames from "classnames";
import "./index.scss";

import VehicleSelector from "../VehicleSelector";
import ColumnTitleWithIcon from "../ColumnTitleWithIcon";

const SectionItemVehicleSelector = ({ column, item, value, onPropChange })=> {

    const handleOnClick = (val) => {
        if(column.isReadonly){
            return;
        }

        onPropChange({ [column.accessor]: val })
    }

    return (
        <div className={classNames("sectionItemVehicleSelector")}>
            <ColumnTitleWithIcon item={item} column={column} onPropChange={onPropChange} />
            <VehicleSelector value={value} 
                onSelect={handleOnClick} 
            />
        </div>
    );
} 

export default SectionItemVehicleSelector;